// import Vue from 'vue';

const createAudioContext = (src, isBgm) => {
  const audioContext = new Audio(require(`@assets/${src}`));
  audioContext.is_bgm = isBgm;
  return audioContext;
};

const audioContexts = {
  indexBgm: createAudioContext("sound/bgm.mp3", true),
    boxBgm: createAudioContext("sound/bgm_box.mp3", true),
    battleBgm: createAudioContext("sound/bgm_battle.mp3", true),
    click: createAudioContext("sound/click.mp3"),
    doorClose: createAudioContext("sound/door_close.mp3"),
    doorOpen: createAudioContext("sound/door_open.mp3"),
    boxSelect: createAudioContext("sound/box_select.mp3"),
    pkTab: createAudioContext("sound/pk_tab.mp3"),
    dialogOpen: createAudioContext("sound/dialog_open.mp3"),
    dialogClose: createAudioContext("sound/dialog_close.mp3"),
    boxSwitch: createAudioContext("sound/box_switch.mp3"),
    boxOpen: createAudioContext("sound/box_open.mp3"),
    boxAnimS: createAudioContext("sound/box_anim_s.mp3"),
    pkJoin: createAudioContext("sound/pk_join.mp3"),
    pkPull: createAudioContext("sound/pk_pull.mp3"),
    pkDown: createAudioContext("sound/pk_down.mp3"),
    opFail: createAudioContext("sound/op_fail.mp3"),
    luckySlide: createAudioContext("sound/lucky_slide.mp3"),
    luckyAnim1: createAudioContext("sound/lucky_anim1.mp3"),
    boxAnimBattle: createAudioContext("sound/box_anim_battle.mp3"),
    pkAnimStop: createAudioContext("sound/pk_anim_stop.mp3"),
    pkAnimWait: createAudioContext("sound/pk_anim_wait.mp3")
};

const soundPlay = (name, loop = false) => {
  const music = localStorage.getItem("music") !== "false";
  const effect = localStorage.getItem("effect") !== "false";
  if (audioContexts[name].is_bgm && !music) {
    return;
  }

  if (!audioContexts[name].is_bgm && !effect) {
    return;
  }

  if (!audioContexts[name].paused) {
    return;
  }

  audioContexts[name].loop = loop;
  audioContexts[name].play();
  // console.log(audioContexts[name], "测试");
};

const soundStop = (name) => {
  audioContexts[name].pause();
};

const AudioPlugin = {
  install(Vue) {
    Vue.prototype.$sound = audioContexts;
    Vue.prototype.$soundPlay = soundPlay;
    Vue.prototype.$soundStop = soundStop;
  },
};

export default AudioPlugin;
